import { render, staticRenderFns } from "./other_data_statistics.vue?vue&type=template&id=1ad3caaa&scoped=true"
import script from "./other_data_statistics.vue?vue&type=script&lang=js"
export * from "./other_data_statistics.vue?vue&type=script&lang=js"
import style0 from "./other_data_statistics.vue?vue&type=style&index=0&id=1ad3caaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3caaa",
  null
  
)

export default component.exports